import { render, staticRenderFns } from "./w-switch.vue?vue&type=template&id=47bba327&scoped=true"
import script from "./w-switch.vue?vue&type=script&lang=ts"
export * from "./w-switch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bba327",
  null
  
)

export default component.exports